import { useWatch } from 'react-hook-form';
import { useSelectPackageContext } from '../../../PackageSelectionForm/selectPackageContext';
import { getSingleProductIdsList } from '../../../../../../helpers/selectPackage/getPreselectedPackageFormValues';
import { PricingPackagesFormValues } from '../../../../../../store/features/packages/types';
import { PricingProductType } from '../../../../../../store/features/products/types';

import { MuiStack } from '../../../../../../../../modules/material';
import CardWrapper from '../../shared/CardWrapper';
import ProductOptions from '../../ProductOptions';
import SecondaryProductCard from '../SecondaryProductCard';
import RadioGroupField from '../../../../../../shared/formElements/RadioGroupField';
import Radio from '../../../../../../shared/library/Radio';

export interface SingleProductsListProps
  extends Pick<PricingProductType, 'products' | 'productTypeId'> {}

export default function SingleProductsList(props: SingleProductsListProps) {
  const { products, productTypeId } = props;
  const fieldName = 'productsSelections.productSingleIdsMap';

  const { handleChangeSelections } = useSelectPackageContext();

  const productSingleIdsMap = useWatch<PricingPackagesFormValues>({
    name: fieldName,
  }) as PricingPackagesFormValues['productsSelections']['productSingleIdsMap'];
  const singleProductIds = getSingleProductIdsList(productSingleIdsMap);

  return (
    <RadioGroupField<PricingPackagesFormValues>
      name={`${fieldName}.${productTypeId}`}
      onChange={() => handleChangeSelections()}
      data-testid="secondary-single-products-list"
      className="informa-payment-single-products"
    >
      <MuiStack spacing={2}>
        {products.map((product) => {
          const isProductOptions =
            product.productOptionsList.length > 0 &&
            singleProductIds.includes(product.id);

          return (
            <CardWrapper
              shiftedContent={
                isProductOptions && (
                  <MuiStack spacing={2.5}>
                    <ProductOptions options={product.productOptionsList} />
                  </MuiStack>
                )
              }
              paddingVariant="smallTopBottom"
              key={product.id}
              className="informa-payment-single-products__item"
            >
              <Radio
                value={product.id}
                label={<SecondaryProductCard product={product} />}
                labelOffset="small"
                sx={{ m: 0 }}
                data-testid="secondary-single-radio-input"
              />
            </CardWrapper>
          );
        })}
      </MuiStack>
    </RadioGroupField>
  );
}
